
import { useStore } from '@/store'
import { EventBuss } from '@/types/global'
import { MessageBoxActionType, MessageBoxEvent } from '@/types/MessageBox'
import { computed, defineComponent, Emitter, inject, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { iconX } from '@/components/icons'
import { AppMutation } from '@/store/types'

type PlayMode = 'classic' | 'special'

export default defineComponent({
    components: {
        'icon-x': iconX
    },
    setup() {
        const store = useStore()
        const emitter = inject('emitter') as Emitter
        const { t } = useI18n()

        const isMobile = computed((): boolean => store.getters['isMobile'])
        const selectedMode = ref<PlayMode>('classic')

        const close = () => {

            if (!highlightSwitchPlayMode.value) return;


            const _evt: MessageBoxEvent = {
                type: MessageBoxActionType.close,
                name: 'game-play'
            }

            emitter.emit(EventBuss.DIALOG, _evt)
        }

        const selectMode = (mode: PlayMode) => {
            selectedMode.value = mode
        }

        onMounted(() => {
            if (playMode.value === 2) {
                selectedMode.value = 'special'
            }
            else {
                selectedMode.value = 'classic'
            }
        })

        const confirm = () => {

            if (!highlightSwitchPlayMode.value) {
                store.commit(AppMutation.SET_HIGHLIGHT_SWITCH_PLAY_MODE, '1')
            }


            if (selectedMode.value === 'special') {
                store.commit(AppMutation.SET_PLAY_MODE, 2)
                // console.log('playMode', 2)
            }
            else if (selectedMode.value === 'classic') {
                store.commit(AppMutation.SET_PLAY_MODE, 1)
                // console.log('playMode', 1)
            }

            const _evt: MessageBoxEvent = {
                type: MessageBoxActionType.close,
                name: 'game-play',
                message: selectedMode.value
            }
            emitter.emit(EventBuss.DIALOG, _evt)
        }

        const cancel = () => {
            close()
        }

        const playMode = computed((): number => store.getters['playMode'])
        const highlightSwitchPlayMode = computed((): boolean => store.getters['highlightSwitchPlayMode'])

        return {
            isMobile,
            selectedMode,
            highlightSwitchPlayMode,
            selectMode,
            confirm,
            close,
            cancel,
            t
        }
    }
})
